import React, { useEffect, useRef, useState } from "react";
import {Card, CardBody, CardTitle, Col, Collapse, FormGroup, Label, Row, Spinner} from "reactstrap";
import { connect, useSelector } from "react-redux";
import { getStateByPath } from "../../../../redux/selectors";
import {
    ADD_STATE,
    REMOVE_STATE,
    setItem,
} from "../../../../redux/actions/generics/IndexedActions";
import { GenericButton } from "../../../../components/buttons/customButtons";
import { genericIndexedActions } from "../../../../redux/actions/generics/GenericIndexedActions";
import {LB_EVENT, NO_DATA_FOUND} from "../../../../components/i18n/i18n";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {typeSeasonProvider} from "../../../../providers/typeSeasonProvider";
import {TT_DELETE, TT_EDIT} from "../../../../components/i18n/toolTips";
import {ActiveFormatter} from "../../../../components/tables/activeFormater";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {scheduleService} from "../../../../jwt/_services/clasificator/scheduleService";
import {seasonService} from "../../../../jwt/_services/clasificator/seasonService";
import {ActivityScheduleSectionForm} from "./_form";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";


const ActivityScheduleSection = (props) => {
    const path = props.path + "/schedules";
    // const [parent] = useState(props.parent || null); // Activity
    // const [app] = useState(props.app || null);
    const parentState = useSelector((state) => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject, app } = parentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;
    const { pageSize } = componentState?.data || 10 ;
    const { pageIndex } = componentState?.data || 0 ;
    const { totalSize } = componentState?.data || 0 ;

    const [showItineraryModal, setShowItineraryModal] = useState(true);
    const itineraryModalRef = useRef(null);

    const [sectionMode, setSectionMode] = useState("regular");
    const [typeSeasonId, setTypeSeasonId] = useState(null);
    const [typeSeasonToday, setTypeSeasonToday] = useState(null);


    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);


    useEffect(() => {
        seasonService.getSeasonToday()
            .then(_typeSeasonToday => {
                if (_typeSeasonToday) {
                    setTypeSeasonToday(_typeSeasonToday);
                    setTypeSeasonId(_typeSeasonToday?.id);
                }
            })
            .catch(error => {
                console.log(error);
            })
    }, []);

    useEffect(() => {
        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                activity: { id: domainObject?.id },
                typeSeason: { id: typeSeasonId }
            },
        };

        genericIndexedActions.search(path, scheduleService, 0, 1000, dataRequest);
    }, [typeSeasonId]);


    const notImplemented = (data) => {
        console.log(data.start, data.end);
    };

    const showForm = (item, start, end) => {
        setShowItineraryModal(true);
        itineraryModalRef.current.showModal(item, start, end);
    };

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex );
    };

    const onAddItem = (data) => {
        showForm(null, data.start, data.end);
    };

    const onEditItem = (_item) => {
        // Busca el item en la lista de items
        const item = listDomainObjects.find((i) => i.id === _item.id);

        setItem(path, item);
        showForm(item);
    };

    const confirmDelete = (data) => {

        genericIndexedActions.delete(path, scheduleService, data.id, app?.fbDataBase?.id)
        //return ConfirmDelete({ path, data : data, fbDataBaseId :  app?.fbDataBase?.id, service: scheduleService, remove : genericIndexedActions.delete } );
    };

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={"table"} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => onEditItem(row)}/>
        <GenericButton style={"danger-secondary"} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: `UID`,
        headerStyle: {width: '200px'},
        hidden: true
    }, {
        dataField: 'typeSeasonName',
        text: 'Temporada',
    }, {
        dataField: 'time24',
        text: 'Hora (24)',
    }, {
        dataField: 'duration',
        text: 'Duración',
    }, {
        dataField: 'status',
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <>
            <div className={'form-container'}>
                <div className={''}>
                    <h2>{'Horarios'}</h2>
                </div>
                <div className={''}>
                    <div className={"vertical-container media-section-body"}>
                        <div>
                            <Row >
                                <Col md={'6'}>
                                    {/*<FormGroup>*/}
                                    {/*    <Label>{'Tipo de temporada'}</Label>*/}
                                    {/*    <SelectGeneric*/}
                                    {/*        provider={typeSeasonProvider}*/}
                                    {/*        initialValue={typeSeasonId}*/}
                                    {/*        setExternalValue={setTypeSeasonId}*/}
                                    {/*    />*/}
                                    {/*</FormGroup>*/}
                                </Col>
                                <Col md={'2'}>
                                </Col>
                                <Col md={'4'}>
                                    <GenericButton label={'Agregar horario'} toolTip={'Agregar'} style={"table"} icon={'fa-plus'}
                                                   permission={'add'} onClick={onAddItem}/>
                                </Col>
                            </Row>
                        </div>

                    </div>
                    {loading ? (
                        <Spinner animation="border"/>
                    ) : (
                        <>
                            <BootstrapTable
                                striped hover
                                tableHeaderClass='mb-0'
                                remote
                                keyField="id"
                                data={listDomainObjects || []}
                                columns={columns}
                                noDataIndication={NO_DATA_FOUND}
                                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                                onTableChange={handleTableChange}
                            />
                        </>
                    )}
                </div>
            </div>
            {showItineraryModal && (
                <ActivityScheduleSectionForm
                    path={path}
                    activity={domainObject}
                    app={app}
                    ref={itineraryModalRef}
                />
            )}
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapActionsToProps)(ActivityScheduleSection);
